import BottomNavbar from "../../components/navs/mobilenav"
import MatchPredictions from "../../components/top-picks/matchcard"
// import { useState } from "react"
// import UpgradePlanModal from "../../components/modals/plans"
import { useUserContext } from "../../context/userContext"
import withAuth from "../../components/user/withAuth"

const TopPicks = () => {
  // const [modalOpen, setModalOpen] = useState(false);

  const { user } = useUserContext();
  
  const avatarUrl = `https://api.dicebear.com/7.x/identicon/svg?seed=${user?.user?.name}`;

  console.log(user)

  return (
    <div className="bg-gray-100 min-h-screen font-sora overflow-x-hidden">
      {/* New Purple Header - Exact Design Match */}
      <div className="text-white px-6 py-8 overflow-x-hidden" style={{ backgroundColor: '#2C0053' }}>
        {/* Main Header Content */}
        <div className="flex items-start justify-between mb-6">
          {/* Welcome Section - Left */}
          <div>
            <h1 className="text-white text-sm font-light mb-1">Top</h1>
            <h2 className="text-white text-[17px] md:text-2xl font-bold">
              Picks ⚽
            </h2>
          </div>

          {/* User Info Section - Right */}
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 rounded-full bg-green-500 flex items-center justify-center overflow-hidden">
              <img
                src={avatarUrl}
                alt="User Avatar"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="p-6">
        <MatchPredictions />
        {/* <UpgradePlanModal isOpen={modalOpen} userPlan={user?.user?.plan} /> */}
      </div>
      
      <BottomNavbar/>
    </div>
  )
}

const TopPicksWithAuth = withAuth(TopPicks);
export default TopPicksWithAuth;
